import axios from "@/libs/api.request";

export const getHomeData = filterCond => {
  return axios.request({
    url: "home/getHomeData",
    data: filterCond,
    csrf: false,
    method: "post"
  });
};
